
import {Component, Prop} from "vue-property-decorator";
import {HcButton, HcPageModel} from "@dev/hc-components";
import ICurrency from "@/module/main/dto/ICurrency";
import OrderItemComponent from "@/module/main/components/OrderItem.vue";
import IOrderItem from "@/module/main/model/applicationForm/IOrderItem";
import OrderItemData from "@/module/main/model/applicationForm/OrderItem";

@Component({
    components: {
        OrderItemComponent,
        HcButton
    }
})
export default class OrderItems extends HcPageModel
{
    @Prop({type: Array}) public value!: IOrderItem[];
    @Prop({type: Object}) public currency!: ICurrency;

    protected pageName: string = "order-items";

    private addNewItem(): void
    {
        this.value.push(new OrderItemData());
    }

    private removeLastItem(): void
    {
        if (this.value.length > 0)
        {
            this.value.pop();
        }
    }
}
